import { notification } from 'antd';

export type Props = {
  type: 'success' | 'error' | 'info';
  message: string;
  description: string;
};

const Notification = (type: Props['type'], message: Props['message'], description: Props['description']) => {
  notification[type]({
    message,
    description,
  });
};
export default Notification;
